import { render } from "./AdvantagesSlider.vue?vue&type=template&id=4ddbcaaa"
import script from "./AdvantagesSlider.vue?vue&type=script&lang=js"
export * from "./AdvantagesSlider.vue?vue&type=script&lang=js"

import "./AdvantagesSlider.vue?vue&type=style&index=0&id=4ddbcaaa&lang=scss"
script.render = render

export default script